export function exportToExcel(headers = [], data = [], filename = "exported-data") {
  // Generate XML content
  const generateExcel = () => {
    let excelContent = '<?xml version="1.0"?><?mso-application progid="Excel.Sheet"?>';
    excelContent += '<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" ';
    excelContent += 'xmlns:o="urn:schemas-microsoft-com:office:office" ';
    excelContent += 'xmlns:x="urn:schemas-microsoft-com:office:excel" ';
    excelContent += 'xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet" ';
    excelContent += 'xmlns:html="http://www.w3.org/TR/REC-html40">';

    excelContent += '<Styles><Style ss:ID="Default" ss:Name="Normal">';
    excelContent += '<Alignment ss:Vertical="Bottom"/>';
    excelContent += '<Borders/><Font/><Interior/><NumberFormat/><Protection/>';
    excelContent += '</Style></Styles>';

    excelContent += '<Worksheet ss:Name="Sheet1"><Table>';

    // Column width calculation
    const columnWidths = {};
    headers.forEach((header, index) => {
      const key = typeof header === "object" ? header.key : index.toString();
      const label = typeof header === "object" ? header.label : header;
      columnWidths[key] = label.length * 7;
    });

    data.forEach(row => {
      headers.forEach((header, index) => {
        const key = typeof header === "object" ? header.key : index.toString();
        const val = typeof header === "object" ? row[header.key] : row[index];
        const len = String(val || "").length * 7;
        columnWidths[key] = Math.max(columnWidths[key] || 0, len);
      });
    });

    // Apply width
    headers.forEach((header, index) => {
      const key = typeof header === "object" ? header.key : index.toString();
      const width = columnWidths[key] || 80;
      excelContent += `<Column ss:Width="${width}" />`;
    });

    // Header row
    excelContent += "<Row>";
    headers.forEach(h => {
      const label = typeof h === "object" ? h.label : h;
      excelContent += `<Cell><Data ss:Type="String">${label}</Data></Cell>`;
    });
    excelContent += "</Row>";

    // Data rows
    data.forEach(row => {
      excelContent += "<Row>";
      headers.forEach((h, index) => {
        const val = typeof h === "object" ? row[h.key] : row[index];

        let type = "String";
        if (typeof val === "number") type = "Number";
        if (val instanceof Date) type = "DateTime";

        const formatted = type === "DateTime" ? val.toISOString() : (val || "");

        excelContent += `<Cell><Data ss:Type="${type}">${formatted}</Data></Cell>`;
      });
      excelContent += "</Row>";
    });

    excelContent += "</Table></Worksheet></Workbook>";
    return excelContent;
  };

  // Trigger download
  const excelContent = generateExcel();
  const blob = new Blob([excelContent], { type: "application/vnd.ms-excel" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.xls`;
  link.click();

  URL.revokeObjectURL(url);
}
